import { RDBiomassBurning } from '@cibo/core'
import { useFigures } from '@cibo/ui'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailPanel } from '../DetailPanel'
import { BiomassBurningPanelTable } from './BiomassBurningPanelTable'

export const BiomassBurningPanel = () => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningPanel')
  const { percent } = useFigures()

  return (
    <DetailPanel<RDBiomassBurning>
      title={t('biomassBurning')}
      traitId="biomassBurning"
      DetailTable={BiomassBurningPanelTable}
      DetailIndividual={({ currentYearData }: { currentYearData?: RDBiomassBurning }) => (
        <Typography variant="subtitle1">
          {currentYearData?.result === 0
            ? t('none')
            : currentYearData?.result
            ? percent(currentYearData.result / 100)
            : '--'}
        </Typography>
      )}
    />
  )
}
